import { useEffect, useState } from 'react';

const loaderImage = `${process.env.PUBLIC_URL}/images/appivorous-mark-light.svg`;

function PageLoader() {
  const [leaving, setLeaving] = useState(false);
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const leaveTimer = window.setTimeout(() => setLeaving(true), 1200);
    const removeTimer = window.setTimeout(() => {
      setMounted(false);
      document.body.style.overflow = previousOverflow;
    }, 1780);

    return () => {
      window.clearTimeout(leaveTimer);
      window.clearTimeout(removeTimer);
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  if (!mounted) return null;

  return (
    <div className={`page-loader ${leaving ? 'is-leaving' : ''}`} role="status" aria-live="polite">
      <div className="page-loader-mark">
        <img src={loaderImage} alt="Appivorous loading" />
      </div>
      <span className="loader-sr-text">Loading Appivorous</span>
    </div>
  );
}

export default PageLoader;